import { Modal, ModalBody, ModalHeader } from '@change/ds-core-ui/next';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import { FlyerDownloadForm } from './components/FlyerDownloadForm';
import { useDownloadFlyerModalBody } from './hooks/useDownloadFlyerModalBody';

type Props = {
	context: Parameters<typeof useDownloadFlyerModalBody>[0]['context'];
	isOpen: boolean;
	onClose: () => void;
};

export function FlyerDownloadModal({ isOpen, context, onClose }: Props) {
	const { translate } = useI18n();
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const {
		data: { templates },
	} = useDownloadFlyerModalBody({ petition, context });
	return (
		<Modal
			className="z-30 [&_section[role=dialog]]:gap-6"
			isOpen={isOpen}
			// To show the X close btn
			onClose={onClose}
			size="large"
		>
			<ModalHeader
				title={translate('corgi.petition.starter_dashboard_v2.grow_petition.share_petition_offline.flyer_modal.title')}
			/>
			<ModalBody>
				<FlyerDownloadForm templates={templates} />
			</ModalBody>
		</Modal>
	);
}
